<div>
    <div class="heading">
        Have you borrowed before?
    </div>

    <div class="mt-2">
        <mat-button-toggle-group [(ngModel)]="borrowedStatus">
            <mat-button-toggle *ngFor="let option of BorrowedOptions"
                               value="{{ option.value }}">{{ option.displayName }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>

<form [formGroup]="debtFormGroup" (ngSubmit)="onSubmit(debtFormGroup)">
    <div *ngIf="showFieldsForDebtInformation()">
        <div class="form-field-heading">
            The number of loans I have
        </div>

        <mat-button-toggle-group formControlName="noOfLoans" id="noOfLoans">
               <mat-button-toggle *ngFor="let option of NoOfLoansOptions"
                                   value="{{ option.value }}">{{ option.displayName }}
               </mat-button-toggle>
         </mat-button-toggle-group>
        <div class="form-field-heading">
            Total EMIs
        </div>

        <p style="color:#4a4a4a; padding-top: 10px">Please include all your current loans including EMIs availed on credit cards</p>

        <mat-form-field style="width:100%">
            <span matPrefix>₹&nbsp;</span>
            <input matInput type="number" placeholder="Sum of all EMIs"
                   formControlName="sumOfEmis">
            <mat-error>{{ getErrorMessage(debtFormGroup.controls.sumOfEmis) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <div class="col-xs-6">
            <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
                <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
            </button>
        </div>
        <div class="col-xs-6">
            <div class="pull-right">
                <app-forward-button class="button-forward" [isLoading]="loaderStatus.isLoading">NEXT</app-forward-button>
            </div>
        </div>
    </div>

</form>
